// @ts-ignore
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { QuestionnaireConditionFragmentDoc } from '../../condition/QuestionnaireCondition.fragment.generated';
export const QuestionnaireQuestionChoiceOptionContentTextConditionalFragmentDoc = gql`
    fragment questionnaireQuestionChoiceOptionContentTextConditional on QuestionnaireQuestionChoiceOptionContentTextConditional {
  title
  description
  conditions {
    ...questionnaireCondition
  }
}
    ${QuestionnaireConditionFragmentDoc}`;